module.exports = {
	"id": "eu",
	"name": "Europe",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.019323,
			"5": 0.012882,
			"6": 0.012882,
			"7": 0.012882,
			"8": 0.006441,
			"9": 0.012882,
			"10": 0.012882,
			"11": 0.038646,
			"12": 0.019323,
			"13": 0.012882,
			"14": 0.019323,
			"15": 0.019323,
			"16": 0.025764,
			"17": 0.025764,
			"18": 0.038646,
			"19": 0.025764,
			"20": 0.025764,
			"21": 0.045087,
			"22": 0.06441,
			"23": 0.032205,
			"24": 0.032205,
			"25": 0.032205,
			"26": 0.038646,
			"27": 0.032205,
			"28": 0.019323,
			"29": 0.025764,
			"30": 0.012882,
			"31": 0.051528,
			"32": 0.019323,
			"33": 0.032205,
			"34": 0.045087,
			"35": 0.045087,
			"36": 0.032205,
			"37": 0.057969,
			"38": 0.051528,
			"39": 0.083733,
			"40": 0.077292,
			"41": 0.06441,
			"42": 0.06441,
			"43": 0.186789,
			"44": 0.057969,
			"45": 0.06441,
			"46": 0.06441,
			"47": 0.083733,
			"48": 0.141702,
			"49": 2.157735,
			"50": 0.289845,
			"51": 0.766479,
			"52": 0.541044,
			"53": 21.371238,
			"54": 5.590788,
			"55": 0.070851,
			"56": 0.019323,
			"57": null
		},
		"firefox": {
			"2": 0.019323,
			"3": 0.057969,
			"4": 0.019323,
			"5": 0.012882,
			"6": 0.006441,
			"7": null,
			"8": 0.006441,
			"9": 0.006441,
			"10": 0.012882,
			"11": 0.012882,
			"12": 0.019323,
			"13": 0.006441,
			"14": 0.012882,
			"15": 0.012882,
			"16": 0.019323,
			"17": 0.012882,
			"18": 0.006441,
			"19": 0.012882,
			"20": 0.019323,
			"21": 0.012882,
			"22": 0.006441,
			"23": 0.012882,
			"24": 0.025764,
			"25": 0.012882,
			"26": 0.012882,
			"27": 0.006441,
			"28": 0.012882,
			"29": 0.012882,
			"30": 0.012882,
			"31": 0.038646,
			"32": 0.019323,
			"33": 0.025764,
			"34": 0.038646,
			"35": 0.045087,
			"36": 0.038646,
			"37": 0.032205,
			"38": 0.173907,
			"39": 0.051528,
			"40": 0.038646,
			"41": 0.051528,
			"42": 0.077292,
			"43": 0.19323,
			"44": 0.199671,
			"45": 0.283404,
			"46": 0.360696,
			"47": 0.760038,
			"48": 0.714951,
			"49": 9.21063,
			"50": 0.096615,
			"51": 0.012882,
			"52": null,
			"3.5": 0.096615,
			"3.6": 0.251199
		},
		"opera": {
			"9": null,
			"11": 0.012882,
			"12": 0.109497,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.012882,
			"19": null,
			"20": 0.012882,
			"21": 0.006441,
			"22": null,
			"23": null,
			"24": 0.006441,
			"25": 0.006441,
			"26": 0.006441,
			"27": 0.051528,
			"28": 0.012882,
			"29": 0.006441,
			"30": 0.006441,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.006441,
			"35": 0.006441,
			"36": 0.096615,
			"37": 0.038646,
			"38": 0.096615,
			"39": 0.045087,
			"40": 0.908181,
			"41": 0.148143,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.006441,
			"10.5": 0.012882,
			"10.6": 0.038646,
			"11.1": 0.012882,
			"11.5": 0.025764,
			"11.6": 0.083733,
			"12.1": 0.528162
		},
		"safari": {
			"0": null,
			"4": 0.051528,
			"5": 0.103056,
			"6": 0.019323,
			"7": 0.038646,
			"8": 0.186789,
			"9": 0.264081,
			"10": 1.751952,
			"3.1": 0.006441,
			"3.2": null,
			"5.1": 0.154584,
			"6.1": 0.077292,
			"7.1": 0.012882,
			"9.1": 1.152939
		},
		"ios_saf": {
			"8": 0,
			"10": 6.24531008576,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.168303880204,
			"8.1-8.4": 0.310934287157,
			"9.0-9.2": 0.148335623231,
			"9.3": 2.26306912365
		},
		"android": {
			"3": 0,
			"4": 0.0404916718346,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00506145897933,
			"4.1": 0.146059244832,
			"4.2-4.3": 0.36514811208,
			"4.4": 0.837309928295,
			"4.4.3-4.4.4": 0.844540583979
		},
		"ie": {
			"6": 0.0130607257204,
			"7": 0.0195910885806,
			"8": 0.359169957311,
			"9": 0.287335965848,
			"10": 0.274275240128,
			"11": 5.16551702241,
			"5.5": null
		},
		"op_mob": {
			"0": 0.03804289843,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00105674717861
		},
		"edge": {
			"12": 0.103056,
			"13": 0.592572,
			"14": 1.842126
		},
		"ie_mob": {
			"10": 0.164215267606,
			"11": 0.668590732394
		},
		"bb": {
			"7": 0.03825925,
			"10": null
		},
		"samsung": {
			"0": 3.669329
		},
		"and_uc": {
			"0": 0.313192
		},
		"op_mini": {
			"0": 0.512545354391
		},
		"and_chr": {
			"0": 19.854864
		},
		"and_ff": {
			"0": 0.042708
		}
	},
	"total": 97.38379225
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/alt-eu.json
 ** module id = 692
 ** module chunks = 0
 **/